var swiper = new Swiper(".swiper-gallery", {
  slidesPerView: 1,
  spaceBetween: 10,
  loop: true,
  centeredSlides: true,
  initialSlide: 1,
  navigation: {
    nextEl: '.slider-button-next',
    prevEl: '.slider-button-prev',
  },
  breakpoints: {
    992: {
        slidesPerView: 3,
        spaceBetween: -50,
      },
  },
});